import { COLORS_DARK_THEME } from 'utilities/styles';

export const DARK_THEME = {
  components: {
    Alert: {
      colorText: COLORS_DARK_THEME.neutral[11],
    },
    Layout: {
      bodyBg: COLORS_DARK_THEME.neutral[0],
      headerBg: COLORS_DARK_THEME.neutral[0],
      siderBg: COLORS_DARK_THEME.neutral[0],
    },
    Message: {
      contentBg: COLORS_DARK_THEME.neutral[2],
    },
    Segmented: {
      trackBg: COLORS_DARK_THEME.neutral[3],
    },
  },
  token: {
    // colorWhite: '#fff', Ant says dont touch
    // colorTextBase: '#000', Ant says dont touch

    colorBgBase: COLORS_DARK_THEME.neutral[0],
    colorBgContainer: COLORS_DARK_THEME.neutral[0],
    colorBgElevated: COLORS_DARK_THEME.neutral[0],
    colorBgLayout: COLORS_DARK_THEME.neutral[0],
    colorBgMask: COLORS_DARK_THEME.neutralAlpha[4],
    colorBgSolid: COLORS_DARK_THEME.neutral[7],
    colorBgHover: COLORS_DARK_THEME.neutral[6],
    colorBgSolidActive: COLORS_DARK_THEME.neutral[8],
    colorBgSpotlight: COLORS_DARK_THEME.neutral[11],
    // colorBgBlur: 'transparent',
    // colorBgTextActive: matches colorFill
    // colorBgTextHover: matches colorFillSecondary
    // colorBgContainerDisabled: matches colorFillTertiary,

    colorBorder: COLORS_DARK_THEME.neutral[4],
    colorBorderSecondary: COLORS_DARK_THEME.neutral[3],
    //colorBorderBg: matches colorTextLightSolid,

    colorFill: COLORS_DARK_THEME.neutral[4],
    colorFillSecondary: COLORS_DARK_THEME.neutral[3],
    colorFillTertiary: COLORS_DARK_THEME.neutral[2],
    colorFillQuaternary: COLORS_DARK_THEME.neutral[1],
    // colorFillAlter: matches colorFillQuaternary
    // colorFillContent: matches colorFillSecondary
    // colorFillContentHover: matches colorFill

    // colorIcon: matches colorTextTertiary,
    // colorIconHover: matches colorText,

    colorLink: COLORS_DARK_THEME.blue[4],
    colorLinkActive: COLORS_DARK_THEME.blue[3],
    colorLinkHover: COLORS_DARK_THEME.blue[5],

    colorText: COLORS_DARK_THEME.neutral[10],
    colorTextSecondary: COLORS_DARK_THEME.neutral[7],
    colorTextTertiary: COLORS_DARK_THEME.neutral[6],
    colorTextQuaternary: COLORS_DARK_THEME.neutral[5],
    colorTextHeading: COLORS_DARK_THEME.neutral[10],
    // colorTextLabel: COLORS_DARK_THEME.red[4], // Not sure why this isnt doing anything
    colorTextLightSolid: COLORS_DARK_THEME.neutral[0],
    colorTextPlaceholder: COLORS_DARK_THEME.neutral[5],
    // colorTextDescription: matches colorTextSecondary
    // colorTextDisabled: matches colorTextTertiary

    colorSplit: COLORS_DARK_THEME.neutral[3], // dividers/hr

    /**
     * Primary
     */
    colorPrimary: COLORS_DARK_THEME.blue[4],
    colorPrimaryActive: COLORS_DARK_THEME.blue[3],
    colorPrimaryHover: COLORS_DARK_THEME.blue[5],
    colorPrimaryBg: COLORS_DARK_THEME.blue[10],
    colorPrimaryBgHover: COLORS_DARK_THEME.blue[9],
    colorPrimaryBorder: COLORS_DARK_THEME.blue[8], // slider
    colorPrimaryBorderHover: COLORS_DARK_THEME.blue[7],
    colorPrimaryText: COLORS_DARK_THEME.blue[4],
    colorPrimaryTextActive: COLORS_DARK_THEME.blue[3],
    colorPrimaryTextHover: COLORS_DARK_THEME.blue[5],

    /**
     * Error / Danger
     */
    colorError: COLORS_DARK_THEME.red[4],
    colorErrorActive: COLORS_DARK_THEME.red[3],
    colorErrorHover: COLORS_DARK_THEME.red[5],
    colorErrorBg: COLORS_DARK_THEME.red[10],
    colorErrorBgActive: COLORS_DARK_THEME.red[8],
    colorErrorBgHover: COLORS_DARK_THEME.red[9],
    colorErrorBgFilledHover: COLORS_DARK_THEME.red[9],
    colorErrorBorder: COLORS_DARK_THEME.red[4],
    colorErrorBorderHover: COLORS_DARK_THEME.red[3],
    colorErrorText: COLORS_DARK_THEME.red[3],
    colorErrorTextActive: COLORS_DARK_THEME.red[2],
    colorErrorTextHover: COLORS_DARK_THEME.red[4],

    /**
     * Info
     */
    colorInfo: COLORS_DARK_THEME.blue[4],
    colorInfoActive: COLORS_DARK_THEME.blue[3],
    colorInfoHover: COLORS_DARK_THEME.blue[5],
    colorInfoBg: COLORS_DARK_THEME.blue[10],
    colorInfoBgActive: COLORS_DARK_THEME.blue[8],
    colorInfoBgHover: COLORS_DARK_THEME.blue[9],
    colorInfoBorder: COLORS_DARK_THEME.blue[4],
    colorInfoBorderHover: COLORS_DARK_THEME.blue[3],
    colorInfoText: COLORS_DARK_THEME.blue[3],
    colorInfoTextActive: COLORS_DARK_THEME.blue[2],
    colorInfoTextHover: COLORS_DARK_THEME.blue[4],

    /**
     * Success
     */
    colorSuccess: COLORS_DARK_THEME.green[4],
    colorSuccessActive: COLORS_DARK_THEME.green[3],
    colorSuccessHover: COLORS_DARK_THEME.green[5],
    colorSuccessBg: COLORS_DARK_THEME.green[10],
    colorSuccessBgActive: COLORS_DARK_THEME.green[8],
    colorSuccessBgHover: COLORS_DARK_THEME.green[9],
    colorSuccessBorder: COLORS_DARK_THEME.green[4],
    colorSuccessgBorderHover: COLORS_DARK_THEME.green[3],
    colorSuccessText: COLORS_DARK_THEME.green[3],
    colorSuccessTextActive: COLORS_DARK_THEME.green[2],
    colorSuccessTextHover: COLORS_DARK_THEME.green[4],

    /**
     * Warning
     */
    colorWarning: COLORS_DARK_THEME.yellow[4],
    colorWarningActive: COLORS_DARK_THEME.yellow[3],
    colorWarningHover: COLORS_DARK_THEME.yellow[5],
    colorWarningBg: COLORS_DARK_THEME.yellow[10],
    colorWarningBgActive: COLORS_DARK_THEME.yellow[8],
    colorWarningBgHover: COLORS_DARK_THEME.yellow[9],
    colorWarningBorder: COLORS_DARK_THEME.yellow[4],
    colorWarningBorderHover: COLORS_DARK_THEME.yellow[3],
    colorWarningText: COLORS_DARK_THEME.yellow[3],
    colorWarningTextActive: COLORS_DARK_THEME.yellow[2],
    colorWarningTextHover: COLORS_DARK_THEME.yellow[4],

    // controlItemBgActive: matches colorPrimaryBg,
    // controlItemBgActiveDisabled: matches colorFill,
    // controlItemBgActiveHover: matches colorPrimaryBgHover,
    // controlItemBgHover: matches colorFillTertiary,
    // controlOutline: 'transparent',
    // controlTmpOutline: matches colorFillQuaternary,

    // EXTRAS. Figure out what to do with these
    // colorBgSolidHover: 'rgba(0, 0, 0, 0.75)',
    // colorErrorOutline: 'rgba(254, 68, 40, 0.19)',
    // colorWarningOutline: 'rgba(245, 180, 14, 0.13)',
    // colorHighlight: '#f87168', For some reason set as Red 400
    // colorSuccessBorderHover: '#9ee8c4', not sure what the hell this is
  },
};
